import _toConsumableArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { createReducer } from '@lib/plugin-redux-core';
import { aiChatHandlers } from './ai-chat/ai-chat.handler';
import { initialAIChatState } from './ai-chat/ai-chat.state';
var initialState = {
  aiChatApp: initialAIChatState,
  fileStorage: {
    error: undefined,
    validatePublicFileUrlStatus: null,
    validatePublicFileUrlOutput: null,
    uploadFileV2Status: null,
    files: [],
    getManyFileV2Status: null,
    deleteFileV2Status: null,
    createFileStorageV2Status: null,
    createFileStorageV2Output: null
  }
};
export var aiChatAppReducer = createReducer(initialState, _toConsumableArray(aiChatHandlers));